import CurrencyInput from '../../../molecules/CurrencyInput';
import { BaseCalculation } from '../types/operations';

interface Props {
    value?: BaseCalculation;
    onChange: (updated: BaseCalculation) => void;
    disabled?: boolean;
}

const FIELDS: Array<{ id: keyof BaseCalculation; label: string; prefix: string; fractionDigits: number }> = [
    { id: 'tir_annual', label: 'TIR (% a.a)', prefix: '', fractionDigits: 4 },
    { id: 'tir_monthly', label: 'TIR (% a.m)', prefix: '', fractionDigits: 4 },
    { id: 'spread_annual', label: 'Spread (% a.a)', prefix: '', fractionDigits: 4 },
    { id: 'vpl', label: 'VPL (R$)', prefix: 'R$', fractionDigits: 2 },
    { id: 'vpl_margin', label: 'Margem VPL (%)', prefix: '', fractionDigits: 4 },
    { id: 'duration_days', label: 'Duration (Dias)', prefix: '', fractionDigits: 0 },
];

const BaseCalculationSection: React.FC<Props> = ({ value, onChange, disabled }) => {
    const handleFieldChange = (field: keyof BaseCalculation, fieldValue: number) => {
        onChange({ ...(value || {}), [field]: fieldValue } as BaseCalculation);
    };

    return (
        <>
            <h2 className="text-xl font-semibold mt-4 mb-4 dark:text-white">Cálculo Base</h2>
            <div className="grid grid-cols-12 gap-4 mb-6">
                {FIELDS.map(({ id, label, prefix, fractionDigits }) => (
                    <div key={id} className="col-span-2">
                        <CurrencyInput
                            id={id}
                            label={label}
                            prefix={prefix}
                            fractionDigits={fractionDigits}
                            value={value?.[id] || 0}
                            onChange={(v) => handleFieldChange(id, v)}
                            disabled={disabled}
                        />
                    </div>
                ))}
            </div>
        </>
    );
};

export default BaseCalculationSection;
